<template>
  <div>
    <div @click="back" class="header border-bottom">
      <i class="iconfont">&#xe604;</i>
    </div>
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="content">
        <div class="list" v-for="item in alist" :key="item.id">
          <div class="mess">
            <div>
              <p>联系人：{{item.name}}</p>
              <p class="tel">{{item.tel}}</p>
            </div>
            <div>
              <span>{{item.state}}</span>
            </div>
          </div>
          <div class="time">
            <p>{{item.time}}<span>￥{{item.price}}</span></p>
          </div>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多清单了~</div>
    </vue-data-loading>
    <div class="footer">
      <button @click="handleSubmitClick">申请结算</button>
    </div>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
export default {
  name: 'ChecklistList',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false
    }
  },
  methods: {
    back () {
      this.$router.push({
        path: '/me'
      })
    },
    /* 获取下一页数据 */
    fetchData () {
      this.loading = true
      this.getChecInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getChecInfo () {
      // 联网请求
      this.axios.get('/ApiMySettleList/GetList', {
        params: {
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getChecInfoSucc)
        .catch(this.getChecInfoFail)
    },
    getChecInfoSucc (res) {
      res = res.data
      var newList = this.list
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.checklistList))
        newList = JSON.parse(data.checklistList)
        if (newList.length === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            setTimeout(() => {
              if (newList[i] <= 10) {
                this.completed = true
                this.loading = false
                return
              }
              const temp = []
              for (let i = newList.length + 1; i <= newList.length + 50; i++) {
                temp.push(i)
              }
              newList = newList.concat(temp)
              this.loading = false
            }, 1000)
            this.alist.push(newList[i])
            // console.log(this.alist)
          }
        }
      }
      // console.log(newList)
    },
    getChecInfoFail (err) {
      alert(err)
    },
    /* 申请结算 */
    handleSubmitClick () {
      this.axios.get('/ApiMySettleList/ApplySettle')
        .then(this.handleSubmitSuccClick)
        .catch(this.handleSubmitFailClick)
    },
    handleSubmitSuccClick (res) {
      res = res.data
      if (res.errorInfo === '') {
        this.$router.push({
          path: '/settle_account',
          query: {
            availamount: JSON.parse(res.data.body).availamount
          }
        })
      } else {
        alert(res.errorInfo)
      }
    },
    handleSubmitFailClick (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.header{ padding: 10px 15px; padding-bottom: 5px;}
.header .iconfont{ font-size: 25px;}
.content{ margin-bottom: 40px;}
.list{ padding: 10px 0; border-bottom: 5px solid #eff3f6;}
.mess{ display: flex; justify-content: space-between; align-items: center; padding: 0 15px; border-bottom: 1px solid #f6f6f6;}
.mess span{ color: #ff6700;}
.mess p{ margin-bottom: 2px;}
.mess .tel{ color: #bdbdbd;}
.time{ padding-top: 5px;}
.time p{ display: flex; justify-content: space-between; padding: 0 15px; font-size: 13px;}
.footer{ position: fixed; bottom: 0; left: 0; right: 0; background-color: #fff;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/checklist/components/List.vue